export default __webpack_public_path__ + "static/media/flagSpecial3.4731b999.svg";